/*

   APP
   Docs: https://front.mosquito.digital/

   Components, Functions and Utilities can be imported via the
   `@mosquitodigitalltd/front-js` package.

*/

/* eslint-disable no-console */
// local components
import FestiveFusions from './components/FestiveFusions';
import Carousel from './components/Carousel';

class App {
  constructor() {
    this.components = [
      {
        src: FestiveFusions,
        options: null
      },
      {
        src: Carousel,
        options: null
      }
    ];

    // add js class to html
    document.documentElement.className = 'js';

    // init array of components
    if (this.components.length) {
      this.components.forEach(component => {
        typeof component.src === 'object' && component.src.init();

        if (typeof component.src === 'function') {
          new component.src(component.selector, component.options).init();
        }
      });
    }

    // this.dynamicWebpackImport();
    // this.setupLazyLoad();
    // this.revealFX();
    // this.stickyHero();
  }

  // dynamicWebpackImport() {
  //   if (document.querySelector('[data-helper="grid"]')) {
  //     import(
  //       /* webpackChunkName: 'helper' */ '@mosquitodigitalltd/front-js/components/Helper'
  //     ).then(component => component.default.init());
  //   }
  //
  //   if (document.querySelector('[data-modal]')) {
  //     import(
  //       /* webpackChunkName: 'modal' */ '@mosquitodigitalltd/front-js/components/Modal'
  //     ).then(component => {
  //       const modal = new component.default('[data-modal]', {
  //         on: {
  //           render: event => {
  //             console.log(event);
  //           },
  //           open: event => {
  //             console.log('Modal component open', event);
  //           },
  //           close: event => {
  //             console.log('Modal component close', event);
  //           }
  //         }
  //       });
  //       modal.init();
  //     });
  //   }
  //
  //   if (document.querySelector('[data-tabs]')) {
  //     import(
  //       /* webpackChunkName: 'tabs' */ '@mosquitodigitalltd/front-js/components/Tabs'
  //     ).then(component => {
  //       const tabs = new component.default('[data-tabs]', {
  //         on: {
  //           render: event => {
  //             console.log(event);
  //           },
  //           change: event => {
  //             console.log('Tabs component change', event);
  //           }
  //         }
  //       });
  //       tabs.init();
  //     });
  //   }
  //
  //   if (document.querySelector('[data-video-embed]')) {
  //     import(
  //       /* webpackChunkName: 'video-embed' */ '@mosquitodigitalltd/front-js/components/VideoEmbed'
  //     ).then(component => {
  //       const videoEmbed = new component.default('[data-video-embed]', {
  //         on: {
  //           render: event => {
  //             console.log(event);
  //           },
  //           create: event => {
  //             console.log('VideoEmbed component create', event);
  //           }
  //         }
  //       });
  //       videoEmbed.init();
  //     });
  //   }
  // }

  setupLazyLoad() {
    const lazyLoad = new LazyLoad({
      root: document.querySelectorAll('[data-src]'),
      rootMargin: '20px 0px 20px 0px',
      threshold: 0
    });
    lazyLoad.render();
  }

  revealFX() {
    const elem = document.querySelectorAll('[data-revealfx]');

    if (!elem.length) return;

    for (let i = 0; i < elem.length; i += 1) {
      const data = elem[i].getAttribute('data-revealfx');
      const revealSettings = JSON.parse(data);
      const instance = new RevealFX(elem[i], revealSettings);

      const callback = (entries, observer) => {
        instance._watch(entries, observer, instance);
      };

      ScrollMonitor.createIO(elem[i], callback);
    }
  }

  stickyHero() {
    const stickyHero = document.querySelectorAll('.js-sticky-hero');

    if (!stickyHero.length) return;

    for (let i = 0; i < stickyHero.length; i += 1) {
      if (
        stickyHero[i].classList.contains('sticky-hero--overlay') ||
        stickyHero[i].classList.contains('sticky-hero--scale')
      ) {
        new StickyHero(stickyHero[i]);
      }
    }
  }
}

window.addEventListener('load', () => new App());
